// Routes/Views del módulo Documentos (Drive multi-tenant).
// El registry declara los tabs:
//   /m/documents/mine          → Mis documentos
//   /m/documents/shared        → Compartidos conmigo
//   /m/documents/org           → De la organización
//   /m/documents/upload        → Subir nuevo

import { useState } from 'react';

import { DocumentList } from './components/DocumentList';
import { DocumentUpload } from './components/DocumentUpload';
import { ShareDialog } from './components/ShareDialog';
import type { DocumentOut, Tab } from './types';

function _DocumentsListView({ tab }: { tab: Tab }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [sharing, setSharing] = useState<DocumentOut | null>(null);

  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold">
          {tab === 'mine'           ? 'Mis documentos'           :
           tab === 'shared_with_me' ? 'Compartidos conmigo'      :
           tab === 'org'            ? 'De la organización'       :
                                       'Todos los documentos'}
        </h1>
        <p className="text-sm text-muted-foreground">
          {tab === 'mine' && 'Documentos que tú has subido — personales o compartidos.'}
          {tab === 'shared_with_me' && 'Otros usuarios de tu organización compartieron contigo estos archivos.'}
          {tab === 'org' && 'Documentos visibles para toda la organización.'}
        </p>
      </div>
      <DocumentList
        tab={tab}
        refreshKey={refreshKey}
        onShareClick={(doc) => setSharing(doc)}
      />
      {sharing && (
        <ShareDialog
          doc={sharing}
          onClose={() => setSharing(null)}
          onShared={() => setRefreshKey((k) => k + 1)}
        />
      )}
    </div>
  );
}

export function DocumentsMineView() {
  return <_DocumentsListView tab="mine" />;
}

export function DocumentsSharedView() {
  return <_DocumentsListView tab="shared_with_me" />;
}

export function DocumentsOrgView() {
  return <_DocumentsListView tab="org" />;
}

export function DocumentsUploadView() {
  // No refresh callback aquí — el user verá el doc nuevo al cambiar de tab.
  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold">Subir documentos</h1>
        <p className="text-sm text-muted-foreground">
          Arrastra y suelta. Se sube apenas lo dejes — sin formulario, sin esperas.
        </p>
      </div>
      <DocumentUpload />
    </div>
  );
}
